module.exports = __webpack_public_path__ + "media/images/common/icon-info-71aeccaed07a0594baf873b4fcbfa9e2.png";